<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1 style="padding-bottom:15px;">Dedication</h1>
<p style="text-align: center;">For Zoe, Eve and Ella for putting up with…me!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?b818a8ea